import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  font-weight: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      flex-grow: 1;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n\n  &:not(:first-child) {\n    margin-left: 12px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import { ellipsis } from 'polished';
import styled, { css } from 'styled-components';
import { Icon } from '@scp/ui-shared/theme/icons';
import { color, typography } from '@scp/ui-shared/theme/variables';
import { Indicator } from '@scp/ui-shared/components/typography';
import { Checkbox } from '@scp/ui-shared/components/switches'; // eslint-disable-next-line import/no-relative-parent-imports

import { Option as DropdownOption } from '../dropdown';
var Label = styled.span(_templateObject(), function (props) {
  return props.withoutIndicator && css(_templateObject2());
}, ellipsis());
var StyledIndicator = styled(Indicator).attrs({
  large: true
})(_templateObject3(), typography.fontWeightSemiBold);
export var Option = function Option(_a) {
  var cx = _a.cx,
      id = _a.id,
      _a$isSelected = _a.isSelected,
      isSelected = _a$isSelected === void 0 ? false : _a$isSelected,
      _a$isFocused = _a.isFocused,
      isFocused = _a$isFocused === void 0 ? false : _a$isFocused,
      children = _a.children,
      _a$isMulti = _a.isMulti,
      isMulti = _a$isMulti === void 0 ? false : _a$isMulti,
      disabled = _a.disabled,
      innerRef = _a.innerRef,
      indicator = _a.indicator,
      optionLabelRenderer = _a.optionLabelRenderer,
      otherProps = __rest(_a, ["cx", "id", "isSelected", "isFocused", "children", "isMulti", "disabled", "innerRef", "indicator", "optionLabelRenderer"]);

  var showCheckIcon = isSelected && !isMulti;
  var title = typeof children === 'string' ? children : '';
  return React.createElement(DropdownOption, Object.assign({
    isSelected: isSelected,
    isFocused: isFocused,
    ref: innerRef,
    isMulti: isMulti,
    id: id,
    disabled: disabled
  }, otherProps), isMulti && React.createElement(Checkbox, {
    disabled: disabled,
    checked: isSelected,
    uiOnly: true,
    hiddenLabel: true,
    id: id,
    label: title
  }), !!optionLabelRenderer ? optionLabelRenderer() : React.createElement(React.Fragment, null, React.createElement(Label, {
    withoutIndicator: !indicator,
    title: title
  }, children), !!indicator && React.createElement(StyledIndicator, null, "(".concat(indicator, ")"))), showCheckIcon && React.createElement(Icon, {
    name: "check",
    color: color.action,
    size: 20
  }));
};